import { useMemo } from 'react';
import { styled } from '@mui/material';
import { KrDetailSkeleton } from '@workboard/ui-okr';
import { TeamKrList } from './TeamKrList';


const Container = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 0px;
`;

export const TeamKeyResultCardList = (props) => {
  const groupedByTeam = useMemo(() => {
    if (props.isLoading || !props.data.length)
      return new Map();
    return props.data.reduce((acc, curr) => {
      const teamName = curr.teamName || '';
      const currentTeam = acc.get(teamName) || [];
      currentTeam.push(curr);
      acc.set(teamName, currentTeam);
      return acc;
    }, new Map());
  }, [props.data, props.isLoading]);

  if (props.isLoading) {
    const krCards = [];

    const count = 2;

    for (let i = 0; i < count; i++) {
      krCards.push(
        <KrDetailSkeleton
          key={i}
        />,
      );
    }

    return <Container>{krCards}</Container>;
  }

  return (
    <>
      {Array.from(groupedByTeam.keys()).map((teamName) => (
        <TeamKrList
          key={teamName}
          teamName={teamName}
          krs={groupedByTeam.get(teamName) ?? []}
        />
      ))}
    </>
  );
};
